<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.supervisor"
        ref="RkmDataTable"
        sort-by="usuario"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click="edit(item.id)"
                authorize="create-cadastro-supervisor"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="destroy(item)"
                authorize="destroy-cadastro-supervisor"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            supervisor: this.getConectaSusRepository('cadastro.supervisor'),
        }
    },
    data: () => ({
        fields: [
            {
                name: 'cadastroUnidade.nomeFantasia',
                key: 'unidade',
                label: 'Unidade',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroUnidade.nomeFantasia',
                key: 'infraestrutura',
                label: 'Local de atendimento',
                searchable: true,
                sortable: true
            },
            {
                name: 'cadastroCidadao.nome',
                key: 'usuario',
                label: 'Profissional',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
    }),
    methods: {
        edit(id) {
            this.$router.push({ name: 'cadastro-supervisor-edit', params: { id } })
        },
        destroy(item) {
            const destroy = () => this.repositories.supervisor.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o supervisor?', destroy)
        },
    },
    mixins: [error, repository],
}
</script>